{
  "WHATSAPP_TEMPLATE_MGMT": {
    "TITLE": "Mallar",
    "DESCRIPTION": "Visa de meddelandemallar som synkroniseras från dina WhatsApp-inkorgar. Skapa eller redigera en mall hos din leverantör.",
    "COUNT": "{n} mall | {n} mallar",
    "LEARN_MORE": "Läs mer om WhatsApp-mallar",
    "SYNC_TEMPLATES": "Synkronisera mallar",
    "SYNC_SUCCESS": "Synkronisering av mallar har startat för alla WhatsApp-inkorgar. Uppdateringarna kan ta ett par minuter.",
    "PARTIAL_SYNC_ERROR": "Synkronisering av mallar har startat för vissa WhatsApp-inkorgar, men andra kunde inte synkroniseras.",
    "SYNC_ERROR": "Det gick inte att starta synkroniseringen av mallar. Försök igen.",
    "SEARCH_PLACEHOLDER": "Sök på innehåll eller namn...",
    "MANAGE_IN_META": "Hantera i Meta",
    "LOADING": "Läser in WhatsApp-mallar...",
    "EMPTY": "Inga WhatsApp-mallar hittades.",
    "NO_RESULTS": "Inga mallar matchar dina filter.",
    "FETCH_ERROR": "Det gick inte att läsa in WhatsApp-mallar. Försök igen.",
    "PARTIAL_FETCH_ERROR": "Vissa WhatsApp-mallar kunde inte läsas in. Försök igen.",
    "LAST_SYNC_ATTEMPT": "Senaste synkroniseringsförsök: {date}",
    "MORE_INBOXES": "+{n}",
    "STATUSES": {
      "UNSUBMITTED": "Inte skickad för godkännande i WhatsApp"
    },
    "FILTERS": {
      "ALL_INBOXES": "Alla inkorgar",
      "ALL_LANGUAGES": "Alla språk",
      "ALL_TYPES": "Alla typer"
    },
    "TYPES": {
      "TEXT": "Text",
      "IMAGE": "Bild",
      "VIDEO": "Video",
      "DOCUMENT": "Dokument",
      "CALL_TO_ACTION": "Uppmaning till handling",
      "COPY_CODE": "Kopiera kod"
    },
    "PREVIEW": {
      "TITLE": "Förhandsgranskning av mall",
      "DESCRIPTION": "Förhandsgranska hur mallen visas i WhatsApp.",
      "OPEN": "Förhandsgranska {name}",
      "CLOSE": "Stäng förhandsgranskning",
      "DETAILS": "Malldetaljer",
      "STATUS": "Status",
      "TYPE": "Innehållstyp",
      "CATEGORY": "Kategori",
      "LANGUAGE": "Språk",
      "INBOXES": "Inkorgar"
    }
  }
}
